<template>
	<div class="c-form-review">
		<section 
			v-for="({ heading, sectionId, items }, index) in validSections"	
			:key="index"
			class="c-form-review__section"
		>
			<header class="c-form-review__header">
				<h3 class="c-form-review__heading">{{ heading }}</h3>
				<button 
					class="c-form-review__button" 
					type="button"
					aria-label="Edit section"
					@click="handleEditClick({ sectionId: sectionId, sectionIndex: index })"
				>Edit</button>
			</header>

			<div class="c-form-review__content">

				<p 
					v-for="(item, index) in validItems(items)"	
					:key="index"
					class="c-form-review__item"
				>
					<span class="c-form-review__title">{{item.title}}:</span>
					<span class="c-form-review__description">{{item.description}}</span>
				</p>

    	</div>
			
		</section>

	</div>
</template>

<script>

export default {
  props: {
		sections: {
      type: Array,
      default: () => []
    },
  },
	computed: {
    validSections() {
      return this.sections.filter(section => section !== null && section !== undefined);
    },
		validItems() {
      return (items) => items.filter(({title, description}) => title !== null && title !== undefined && title !== "" && description !== null && description !== undefined && description !== "");
    },

  },
  methods: {
    handleEditClick({ sectionId, sectionIndex }) {
  	 this.$emit('editSection', sectionId, sectionIndex);
		},
  }
};
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/form-review/FormReview.vue